import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Radio, RadioGroup, Stack } from '@chakra-ui/react';




const ThemeBuilder = ({ boardData, setBoardData}) => {
    
    const [selected, setSelected] = useState('bgColor');
    
    function setter(color) {
        let tempTheme = {...boardData.theme};
        let tempBoardData = {...boardData};
        tempTheme[selected] = color;
        tempBoardData.theme = tempTheme;
        setBoardData(tempBoardData);
    }
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'start', width: '100%', padding: '3em'}}>
            <HexColorPicker color={boardData.theme[selected]} onChange={setter}/>
            <RadioGroup onChange={setSelected} value={selected}>
              <Stack marginTop='3em' direction='column'>
                <Radio value='bgColor'>BackGround</Radio>
                <Radio value='cardColor'>Card</Radio>
                <Radio value='fontColor'>Font</Radio>
              </Stack>
            </RadioGroup>
        </div>
    );
};

export default ThemeBuilder;


//